import styled, { css } from 'styled-components'
import { Header, Footer, NavPanel, ScrollBtn, ContactWidgetButton } from '@/components'
import { FormPageProvider } from '@/contexts/FormPageContext'
import { directionSlugFromField, directionSlugsFromServices } from '@/lib/formDirection'

function pageField(props, key) {
  if (props[key] != null && props[key] !== '') return props[key]
  if (props.data && props.data[key] != null && props.data[key] !== '') return props.data[key]
  return ''
}

function formDirectionFromPage(props) {
  return directionSlugFromField(pageField(props, 'form_direction'))
}

function specialistIds(list) {
  const ids = []
  const seen = new Set()
  ;(list || []).forEach((item) => {
    if (item == null || item === '') return
    const id = typeof item === 'object' ? item.id : item
    if (id == null || id === '' || seen.has(String(id))) return
    seen.add(String(id))
    ids.push(id)
  })
  return ids
}

function pageSpecialistsFromPage(props) {
  if (props.pageType !== 'direction' && props.pageType !== 'service') return []
  const list = Array.isArray(props.specialists)
    ? props.specialists
    : props.data && Array.isArray(props.data.specialists)
      ? props.data.specialists
      : []
  return specialistIds(list)
}

function serviceDirectionsFromPage(props) {
  if (props.pageType !== 'specialist') return []
  const services = Array.isArray(props.services)
    ? props.services
    : props.data && Array.isArray(props.data.services)
      ? props.data.services
      : []
  return directionSlugsFromServices(services)
}

function formDoctorFromPage(props) {
  const raw = pageField(props, 'form_doctor')
  if (raw != null && raw !== '') return raw.id || raw
  if (props.pageType === 'specialist') return props.id || ''
  return ''
}

export default function Page({ children, menu, ...props }) {
  const isDoctor = props.first_name && props.last_name;
  const isContacts = props.pageType == 'contacts';
  const formDirection = formDirectionFromPage(props)

  return (
    <FormPageProvider
      formDirection={formDirection}
      formDoctor={formDoctorFromPage(props)}
      serviceDirections={serviceDirectionsFromPage(props)}
      pageSpecialists={pageSpecialistsFromPage(props)}
      fillFromSpecialists={props.pageType === 'direction' || props.pageType === 'service'}
    >
    <StyledPage >
      <Header menu={menu} />
      <NavPanel menu={menu} />
      <StyledContent hide={isContacts}>{children}</StyledContent>
    <Footer menu={menu} isTop={!isDoctor} stretch={isContacts} large={isContacts} h1={isContacts ? props.meta?.h1 : undefined}/>
      <ScrollBtn />
      <ContactWidgetButton />
    </StyledPage>
    </FormPageProvider>
  )
}

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 320px;
`

const StyledContent = styled.main`
  flex: 1 0 auto;
  display:flex;
  flex-direction:column;
  width:100%;
  ${(props) =>
    props.hide  &&
    css`
      display:none;
    `}
`
